import React from 'react'
import { ExerciseDefinition } from '../utils/exercise'
import { Pose } from '../utils/pose'
import { HealthBar } from './HealthBar'

export interface ExerciseBarsProps {
  /** Current exercise data */
  exercise: ExerciseDefinition | null;
  /** Current pose for comparison */
  currentPose: Pose | null;
  /** Current state index */
  currentState: number;
  /** Rep count */
  repCount: number;
  /** Whether the exercise is dual-sided */
  dualSided?: boolean;
  /** Best score threshold for keypose selection */
  bestScoreThreshold: number;
}

/**
 * Remaps a value from one range to another.
 * @param value - Value to remap
 * @param fromMin - Source range minimum
 * @param fromMax - Source range maximum
 * @param toMin - Target range minimum
 * @param toMax - Target range maximum
 * @returns Remapped value
 */
// function remap (value: number, fromMin: number, fromMax: number, toMin: number, toMax: number): number {
//   const normalized = (value - fromMin) / (fromMax - fromMin)

//   return normalized * (toMax - toMin) + toMin
// }

export const ExerciseBars: React.FC<ExerciseBarsProps> = ({
  exercise,
  currentPose,
  currentState,
  repCount,
  dualSided = false,
  bestScoreThreshold,
}) => {
  if (!exercise || !currentPose) {
    return null
  }

  // Calculate state progress
  let statePercent = 0
  if (currentState !== -1) {
    statePercent = 5 + (90 * (currentState / (exercise.keyposes.length - 1)))
  }

  // Format reps text
  const repsText = dualSided
    ? `Reps: ${repCount} / ? (${bestScoreThreshold})`
    : `Reps: ${repCount}`

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: '2px',
        margin: '8px',
        zIndex: 100,
      }}
    >
      {/* State bar showing current rep progress */}
      <HealthBar
        progress={repCount / 10.0 * 100}
        text={repsText}
        width={200}
        height={50}
        showCursor={true}
        cursorPosition={statePercent}
      />

      {/* Keypose bars */}
      {/* {exercise.keyposes.map((keypose, index) => {
        // Calculate pose score
        const score = currentPose.calcPoseScore(keypose, exercise.weights)
        const progress = remap(score, 0, 1, 0, 100)
        const selected = progress >= 100 * bestScoreThreshold

        const text = `Keypose ${index}: ${score.toFixed(2)}`

        return (
          <HealthBar
            key={index}
            progress={progress}
            text={text}
            width={200}
            height={20}
            showCursor={true}
            cursorPosition={progress}
            selected={selected}
          />
        )
      })} */}
    </div>
  )
}

export default ExerciseBars
